var map = {
	"./deposits/locales/es/deposits.yml": [
		99088,
		[
			9088
		]
	],
	"./tradingview/locales/es/tradingview.yml": [
		92332,
		[
			2332
		]
	],
	"./tyc_signing/locales/es/tyc_signing.yml": [
		82180,
		[
			2180
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 21695;
module.exports = webpackAsyncContext;